import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _StopLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M5 16.738V7.262q0-.94.66-1.601Q6.323 5 7.263 5h9.476q.94 0 1.601.66.66.662.661 1.602v9.476q0 .94-.66 1.601-.662.66-1.602.661H7.262q-.94 0-1.601-.66Q5 17.677 5 16.737m2.262.862h9.476a.84.84 0 0 0 .62-.242.84.84 0 0 0 .242-.62V7.262a.84.84 0 0 0-.242-.62.84.84 0 0 0-.62-.242H7.262a.84.84 0 0 0-.62.242.84.84 0 0 0-.242.62v9.476q0 .377.242.62a.84.84 0 0 0 .62.242" })));
}
const StopLight = forwardRef(_StopLight);
export { StopLight };
